@if (_show) {
  <div
    class="loading-indicator__backdrop"
    @parentAnimation
    [class]="'loading-indicator__backdrop--' + indicatorStyle"
  ></div>
}

@if (_show) {
  <div class="loading-indicator__spinner" @childAnimation data-loader="ball-pulse"></div>
}
